import { Injectable } from '@angular/core';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import { LineTool } from '../line/line-tool';

@Injectable()
export class ArrowTool extends LineTool {
  override readonly name = vectorTaggingToolsConfig.Arrow.name;
  protected override readonly shapeType = 'arrow';
}
